import { render, staticRenderFns } from "./index.vue?vue&type=template&id=37fd1f40&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=37fd1f40&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fd1f40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37fd1f40')) {
      api.createRecord('37fd1f40', component.options)
    } else {
      api.reload('37fd1f40', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=37fd1f40&scoped=true", function () {
      api.rerender('37fd1f40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/material/chart/index.vue"
export default component.exports